<template>
  <div>
    <img
      ref="image"
      src="../../assets/dark/SurveillanceDormitory105Alive.gif"
    >
  </div>
</template>

<script>
import Zoomable from '../../mixins/zoomable'

export default {
  name: 'InvestigationPerimeter',

  mixins: [Zoomable],

  mounted() {
    const width = this.$el.clientWidth * 2
    const container = document.querySelector('.section-layout__main')
    this.$refs.image.style.width = `${width}px`
    container.scrollTo(width, 0)
  },
}
</script>

<style lang="postcss" scoped>
img {
  max-width: 10000px;
}
</style>
